var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.888672 14.0934H15.111V15.1112H0.888672V14.0934Z",
    fill: "#D0004B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59551 3.26233L1.69779 9.72462L1.47559 12.92L4.68444 12.9245L11.5422 6.49337L8.59551 3.26233Z",
    fill: "#D0004B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.973 3.46659L11.7508 1.06659C11.6516 0.959118 11.5136 0.895723 11.3674 0.890703C11.2213 0.885681 11.0792 0.939475 10.973 1.03992L9.33301 2.56884L12.2842 5.7777L13.9464 4.21764H13.9463C14.046 4.11965 14.1042 3.98717 14.1093 3.84744C14.1142 3.70771 14.0654 3.57143 13.973 3.46652L13.973 3.46659Z",
    fill: "#D0004B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9f39dd09d4c4c7cda02f291ff88f475e.svg";
export { ForwardRef as ReactComponent };